
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33881',
  depVersions: {
  "documents-public-ui": "static-1.33881",
  "client-types": "static-1.444",
  "documents-lib": "static-1.33886",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1889",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4754",
  "highcharts": "static-8.98",
  "hs-promise-utils": "static-1.5355",
  "hs-test-utils": "static-1.7770",
  "hub-http": "static-1.5966",
  "hubspot-dlb": "static-2.1796",
  "HubStyleTokens": "static-2.11187",
  "I18n": "static-7.1558",
  "jasmine-immutable": "static-1.2783",
  "jasmine-runner": "static-1.6238",
  "lodash": "static-1.3",
  "quartz": "static-1.6679",
  "react": "static-7.177",
  "react-dlb": "static-1.71",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.66",
  "react-rhumb": "static-1.16405",
  "reporting-data": "static-1.66356",
  "reporting-testing-lib": "static-1.8289",
  "reporting-visualizations": "static-1.58432",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4530",
  "webpack-env": "static-1.54",
  "atom": "static-1.4835",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2250",
  "classnames": "static-2.10",
  "cssUtils": "static-1.721",
  "customer-data-filters-ui": "static-1.38748",
  "customer-data-objects": "static-1.7408",
  "customer-data-property-utils": "static-1.7836",
  "data-fetching-client": "static-1.9441",
  "enviro": "static-4.387",
  "FireAlarmUi": "static-1.4295",
  "flux-actions": "static-1.302",
  "FormsCommonComponents": "static-1.85203",
  "FormUrlGenerator": "static-2.4495",
  "foundations-components": "static-1.7451",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3917",
  "HubStyle": "static-2.11495",
  "icons": "static-2.618",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6927",
  "metrics-js": "static-1.9391",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.349",
  "property-description-translator": "static-1.3624",
  "property-translator": "static-1.5178",
  "quartz-config": "static-1.457",
  "quartz-core": "static-1.5898",
  "quick-fetch": "static-1.3700",
  "raven": "static-3.5624",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5142",
  "react-virtualized": "static-2.93",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7924",
  "reference-resolvers-lite": "static-1.7854",
  "report-customization-components": "static-1.12387",
  "reporting-enablement": "static-1.21946",
  "reporting-reports": "static-1.66034",
  "reporting-snowflake": "static-1.54974",
  "reporting-ui-components": "static-2.63628",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4396",
  "sales-content-partitioning": "static-1.8699",
  "SalesContentIndexUI": "static-3.8849",
  "sanitize": "static-1.4239",
  "sanitize-text": "static-1.7904",
  "self-service-api": "static-1.9999",
  "SharedI18nStrings": "static-1.180",
  "SharedLegalStrings": "static-1.1518",
  "signup-constants": "static-1.18316",
  "signup-ui-lego-core": "static-1.20326",
  "signup-ui-url-generator": "static-2.7827",
  "styled-components": "static-2.84",
  "StyleGuideUI": "static-3.483",
  "superstore": "static-1.4536",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10759",
  "ui-addon-i18n": "static-1.10895",
  "ui-addon-react-router-dom": "static-1.9312",
  "ui-addon-upgrades": "static-9.17597",
  "ui-asset-management-lib": "static-1.10662",
  "ui-images": "static-2.1083",
  "UIComponents": "static-3.8134",
  "usage-tracker": "static-1.7098",
  "usage-tracker-container": "static-1.7088",
  "usage-tracker-core": "static-1.6948",
  "usage-tracker-public": "static-1.6909",
  "viral-links-lib": "static-1.6792",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven-hubspot": "static-1.5931",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3195",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2956",
  "quartz-webpack": "static-1.2903",
  "ai-components-ui-library": "static-1.8252",
  "amplitude-session-replay-browser": "static-1.54",
  "foundations-assets": "static-1.4596",
  "foundations-theming": "static-1.4173",
  "quartz-auth": "static-1.354",
  "usage-tracker-session-replay": "static-1.4784",
  "foundations-theming-base": "static-1.3158",
  "HeadJS": "static-2.701",
  "framer-motion": "static-1.66",
  "hs-test-utils-bend-plugin": "static-1.2881",
  "msw": "static-1.39",
  "testing-library": "static-1.146",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.77",
  "jasmine": "static-4.4095",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7691",
  "graphql": "static-1.76",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3397",
  "persist-promise": "static-1.3471",
  "reporting-client-types": "static-1.2372",
  "hs-story-utils": "static-1.9192",
  "react-flip-move": "static-1.64",
  "hub-http-shared-msw-handlers": "static-1.9390",
  "hubspotter-http": "static-1.4446",
  "sassPrefix": "static-1.151",
  "conversations-skeleton-state": "static-1.7014",
  "crm-message-bus": "static-1.42241",
  "customer-data-filters-ui-msw-helpers": "static-1.21182",
  "customer-data-objects-ui-components": "static-1.12767",
  "customer-data-reference-ui-components": "static-1.12905",
  "customer-data-ui-utilities": "static-1.9589",
  "framework-builder-read-service-client": "static-1.3815",
  "framework-data-schema-quick-fetch": "static-1.6539",
  "framework-data-schema-resolvers": "static-1.6634",
  "inbound-db-properties-service-client": "static-1.3644",
  "multi-account-reference-resolvers": "static-1.733",
  "onboarding-tours": "static-1.16209",
  "reporting-datasets-permissions-lib": "static-1.12947",
  "ui-addon-teams": "static-1.21192",
  "apollo-stack-hubspot": "static-3.80",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67517",
  "customer-data-properties": "static-1.50679",
  "forms-ai-lib": "static-1.3960",
  "forms-utils-lib": "static-1.12104",
  "foundations-components-test-utils": "static-1.4934",
  "react-dnd-compat": "static-1.4388",
  "react-tinymce": "static-1.54523",
  "tinymce-config": "static-2.53649",
  "ui-gdpr-components": "static-1.10111",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3720",
  "floating-ui": "static-1.50",
  "react-aria": "static-1.60",
  "tanstack-table": "static-1.49",
  "trellis-assets": "static-1.1092",
  "ui-fonts": "static-1.449",
  "dispatcher": "static-1.130",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.784",
  "mobile-manifest-mixins": "static-1.474",
  "quartz-head": "static-1.344",
  "quartz-i18n": "static-1.354",
  "quartz-routing": "static-1.109",
  "quartz-test": "static-1.354",
  "batch-promise": "static-1.1314",
  "external-options-client-types": "static-1.3951",
  "react-colorpicker": "static-2.9976",
  "copilot-toolkit": "static-1.10431",
  "data-quality-ui-library": "static-1.12237",
  "html-to-image": "static-1.48",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40544",
  "reporting-insights-lib": "static-1.1054",
  "reporting-plugins": "static-1.9936",
  "ui-addon-draggable-compat": "static-2.4018",
  "ui-addon-opt": "static-4.8151",
  "ui-shepherd-react": "static-3.9909",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24623",
  "hubspot-apollo-client": "static-1.4643",
  "sales-templates-service-types-lib": "static-1.3961",
  "ui-business-units-lib": "static-1.8787",
  "merchandise-lib": "static-1.257",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5432",
  "salesImages": "static-1.520",
  "ts-schema": "static-1.3872",
  "upgrade-management-service-types": "static-1.4272",
  "timezone-utils": "static-2.5009",
  "bender-build-tools": "static-1.2899",
  "chatspot-core": "static-1.20165",
  "chirp-fetch": "static-1.1647",
  "bend-plugin-foundations-theming": "static-1.2656",
  "stylex": "static-1.26",
  "hubspotter-http-shared-msw-handlers": "static-1.9388",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3591",
  "crm-pipelines-api-client-types": "static-1.3932",
  "multi-currency-client-types": "static-1.3486",
  "getting-started-shared-tasks": "static-1.17778",
  "growth-data-modal": "static-1.5118",
  "growth-onboarding-confetti": "static-1.2834",
  "growth-onboarding-next-action-utils": "static-1.1259",
  "navigation-components": "static-1.17147",
  "onboarding-tours-client": "static-1.4423",
  "onboarding-tours-utils": "static-1.275",
  "ui-shepherd-tracker": "static-1.7290",
  "ui-universal-auth": "static-1.8641",
  "user-context": "static-1.4859",
  "cms-field-types": "static-1.4571",
  "content-icons-ui": "static-1.2142",
  "integrations-lib": "static-1.15296",
  "calling-global-api": "static-1.63527",
  "calling-internal-common": "static-1.31056",
  "calling-lifecycle-internal": "static-1.64909",
  "calling-lifecycle-messages": "static-1.57203",
  "commerce-products-lib": "static-1.8744",
  "crm-links": "static-1.6018",
  "file-manager-components": "static-1.22778",
  "google-libphonenumber": "static-1.32",
  "hs-entities": "static-1.435",
  "inbounddb-objects-service-types": "static-1.4018",
  "meetings-icalendar-utils-lib": "static-1.398",
  "object-builder-ui-client": "static-1.47848",
  "pipeline-validation-client-types": "static-1.3755",
  "property-value-citations": "static-1.1293",
  "pulse": "static-1.265",
  "smart-property-lib": "static-1.5748",
  "tiered-pricing": "static-1.777",
  "ui-addon-iframeable": "static-1.8805",
  "final-form": "static-1.64",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19413",
  "tinymce-themes": "static-1.55619",
  "data-token-picker": "static-1.15987",
  "hub-http-contrib": "static-1.2809",
  "interframe": "static-3.4556",
  "tinymce-data": "static-1.39734",
  "tinymce-plugins": "static-1.56763",
  "ui-addon-sales-email": "static-1.4977",
  "magpie-lib": "static-1.5358",
  "magpie-types": "static-1.4818",
  "simple-logging-lib": "static-1.2815",
  "content-assistance-lib": "static-1.7395",
  "dashboard-lib": "static-1.80462",
  "ExportDialog": "static-6.10152",
  "hubspot-prosemirror": "static-1.17501",
  "hubspot-prosemirror-plugins": "static-1.17493",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8454",
  "campaign-roi-lib": "static-1.8182",
  "feedback-loader": "static-1.28785",
  "onboarding-scopes": "static-1.6229",
  "apollo-link-hub-http": "static-2.4413",
  "hubspot-apollo-cache": "static-1.102",
  "growth-monetization-service-types": "static-1.4288",
  "nav-client-types": "static-1.2120",
  "purchase-motions-api": "static-1.5435",
  "trials-service-types": "static-1.3689",
  "idb-keyval": "static-1.38",
  "reactive-lib": "static-1.490",
  "getting-started-shared-tasks-store": "static-1.16896",
  "integrations-error-boundary-lib": "static-1.12711",
  "integrations-tracking-lib": "static-1.5348",
  "native-integrations-shared-strings": "static-1.7553",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10137",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31062",
  "shared-worker-versioning": "static-1.10802",
  "calling-usage-tracker": "static-1.6303",
  "voice-sms-access-library": "static-1.131",
  "customer-data-tracking": "static-1.6646",
  "products-iframe-lib": "static-1.7218",
  "products-ui-components-shared-msw-handlers": "static-1.9772",
  "location-customization-utils-lib": "static-1.8442",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3919",
  "video-components-external": "static-1.10467",
  "video-data-lib": "static-1.34125",
  "directed-graph": "static-1.701",
  "event-emitter": "static-1.712",
  "breeze-intelligence-kit": "static-1.5268",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9473",
  "fsm": "static-1.3496",
  "policy-lib": "static-1.6549",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9536",
  "navigation-messaging": "static-1.6474",
  "FileManagerLib": "static-1.38418",
  "NamespacedHubStyle": "static-2.8864",
  "FileManagerCore": "static-1.38277",
  "codemirror": "static-5.89",
  "layout-dnd-components": "static-1.11968",
  "layout-dnd-utils": "static-1.10943",
  "react-codemirror": "static-1.10392",
  "ui-addon-emoji-picker": "static-1.9654",
  "ui-brand-identity-lib": "static-1.13685",
  "ui-addon-video-player": "static-1.8459",
  "ui-coaching-tips": "static-1.27848",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8332",
  "payment-link-components": "static-1.22834",
  "EmailSignatureEditor": "static-1.23859",
  "eligibility-engine-service-types": "static-1.2970",
  "universal-page-editor-lib": "static-1.2763",
  "calling-orchestration-schema": "static-1.34908",
  "sales-views-client-types": "static-1.4056",
  "crm-record-cards-service-types": "static-1.3419",
  "content-media-composition-data-lib": "static-1.11320",
  "content-media-compositions": "static-2.15327",
  "media-bridge-lib": "static-1.18509",
  "trellis-story-utils": "static-1.4286",
  "storybook-react": "static-1.27",
  "audio-components": "static-1.5560",
  "FileManagerImages": "static-1.35929",
  "video-components": "static-1.12470",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4297",
  "video-embed": "static-1.34959",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67592",
  "layout-data-lib": "static-1.9268",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6350",
  "commerce-tours-lib": "static-1.5663",
  "growth-onboarding-reliability": "static-1.4853",
  "sales-checkout-service-client": "static-1.3441",
  "draft-convert": "static-2.31",
  "draft-extend": "static-3.69",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.21251",
  "sales-email-signature-service-client": "static-1.3607",
  "hls.js": "static-1.33",
  "social-insights-client-types": "static-1.21253",
  "outpost": "static-1.3972",
  "advanced-menus-core": "static-1.14763",
  "advanced-menus-lib": "static-1.11745",
  "ui-memberships-settings-lib": "static-1.33331",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14762",
  "simple-menus-lib": "static-1.16279"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33881",
  "client-types": "/client-types/static-1.444",
  "documents-lib": "/documents-lib/static-1.33886",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1889",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4754",
  "highcharts": "/highcharts/static-8.98",
  "hs-promise-utils": "/hs-promise-utils/static-1.5355",
  "hs-test-utils": "/hs-test-utils/static-1.7770",
  "hub-http": "/hub-http/static-1.5966",
  "hubspot-dlb": "/hubspot-dlb/static-2.1796",
  "HubStyleTokens": "/HubStyleTokens/static-2.11187",
  "I18n": "/I18n/static-7.1558",
  "jasmine-immutable": "/jasmine-immutable/static-1.2783",
  "jasmine-runner": "/jasmine-runner/static-1.6238",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6679",
  "react": "/react/static-7.177",
  "react-dlb": "/react-dlb/static-1.71",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.66",
  "react-rhumb": "/react-rhumb/static-1.16405",
  "reporting-data": "/reporting-data/static-1.66356",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8289",
  "reporting-visualizations": "/reporting-visualizations/static-1.58432",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4530",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4835",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2250",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.721",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38748",
  "customer-data-objects": "/customer-data-objects/static-1.7408",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7836",
  "data-fetching-client": "/data-fetching-client/static-1.9441",
  "enviro": "/enviro/static-4.387",
  "FireAlarmUi": "/FireAlarmUi/static-1.4295",
  "flux-actions": "/flux-actions/static-1.302",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85203",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4495",
  "foundations-components": "/foundations-components/static-1.7451",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
  "HubStyle": "/HubStyle/static-2.11495",
  "icons": "/icons/static-2.618",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6927",
  "metrics-js": "/metrics-js/static-1.9391",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "property-description-translator": "/property-description-translator/static-1.3624",
  "property-translator": "/property-translator/static-1.5178",
  "quartz-config": "/quartz-config/static-1.457",
  "quartz-core": "/quartz-core/static-1.5898",
  "quick-fetch": "/quick-fetch/static-1.3700",
  "raven": "/raven/static-3.5624",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5142",
  "react-virtualized": "/react-virtualized/static-2.93",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7924",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7854",
  "report-customization-components": "/report-customization-components/static-1.12387",
  "reporting-enablement": "/reporting-enablement/static-1.21946",
  "reporting-reports": "/reporting-reports/static-1.66034",
  "reporting-snowflake": "/reporting-snowflake/static-1.54974",
  "reporting-ui-components": "/reporting-ui-components/static-2.63628",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4396",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8699",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8849",
  "sanitize": "/sanitize/static-1.4239",
  "sanitize-text": "/sanitize-text/static-1.7904",
  "self-service-api": "/self-service-api/static-1.9999",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1518",
  "signup-constants": "/signup-constants/static-1.18316",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20326",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7827",
  "styled-components": "/styled-components/static-2.84",
  "StyleGuideUI": "/StyleGuideUI/static-3.483",
  "superstore": "/superstore/static-1.4536",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10759",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10895",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9312",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17597",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10662",
  "ui-images": "/ui-images/static-2.1083",
  "UIComponents": "/UIComponents/static-3.8134",
  "usage-tracker": "/usage-tracker/static-1.7098",
  "usage-tracker-container": "/usage-tracker-container/static-1.7088",
  "usage-tracker-core": "/usage-tracker-core/static-1.6948",
  "usage-tracker-public": "/usage-tracker-public/static-1.6909",
  "viral-links-lib": "/viral-links-lib/static-1.6792",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3195",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2956",
  "quartz-webpack": "/quartz-webpack/static-1.2903",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8252",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.54",
  "foundations-assets": "/foundations-assets/static-1.4596",
  "foundations-theming": "/foundations-theming/static-1.4173",
  "quartz-auth": "/quartz-auth/static-1.354",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4784",
  "foundations-theming-base": "/foundations-theming-base/static-1.3158",
  "HeadJS": "/HeadJS/static-2.701",
  "framer-motion": "/framer-motion/static-1.66",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2881",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.146",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.77",
  "jasmine": "/jasmine/static-4.4095",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7691",
  "graphql": "/graphql/static-1.76",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3397",
  "persist-promise": "/persist-promise/static-1.3471",
  "reporting-client-types": "/reporting-client-types/static-1.2372",
  "hs-story-utils": "/hs-story-utils/static-1.9192",
  "react-flip-move": "/react-flip-move/static-1.64",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9390",
  "hubspotter-http": "/hubspotter-http/static-1.4446",
  "sassPrefix": "/sassPrefix/static-1.151",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7014",
  "crm-message-bus": "/crm-message-bus/static-1.42241",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21182",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12767",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12905",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9589",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3815",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6539",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6634",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3644",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.733",
  "onboarding-tours": "/onboarding-tours/static-1.16209",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12947",
  "ui-addon-teams": "/ui-addon-teams/static-1.21192",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.80",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67517",
  "customer-data-properties": "/customer-data-properties/static-1.50679",
  "forms-ai-lib": "/forms-ai-lib/static-1.3960",
  "forms-utils-lib": "/forms-utils-lib/static-1.12104",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4934",
  "react-dnd-compat": "/react-dnd-compat/static-1.4388",
  "react-tinymce": "/react-tinymce/static-1.54523",
  "tinymce-config": "/tinymce-config/static-2.53649",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10111",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3720",
  "floating-ui": "/floating-ui/static-1.50",
  "react-aria": "/react-aria/static-1.60",
  "tanstack-table": "/tanstack-table/static-1.49",
  "trellis-assets": "/trellis-assets/static-1.1092",
  "ui-fonts": "/ui-fonts/static-1.449",
  "dispatcher": "/dispatcher/static-1.130",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.784",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.474",
  "quartz-head": "/quartz-head/static-1.344",
  "quartz-i18n": "/quartz-i18n/static-1.354",
  "quartz-routing": "/quartz-routing/static-1.109",
  "quartz-test": "/quartz-test/static-1.354",
  "batch-promise": "/batch-promise/static-1.1314",
  "external-options-client-types": "/external-options-client-types/static-1.3951",
  "react-colorpicker": "/react-colorpicker/static-2.9976",
  "copilot-toolkit": "/copilot-toolkit/static-1.10431",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12237",
  "html-to-image": "/html-to-image/static-1.48",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40544",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1054",
  "reporting-plugins": "/reporting-plugins/static-1.9936",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4018",
  "ui-addon-opt": "/ui-addon-opt/static-4.8151",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9909",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24623",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4643",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3961",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8787",
  "merchandise-lib": "/merchandise-lib/static-1.257",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5432",
  "salesImages": "/salesImages/static-1.520",
  "ts-schema": "/ts-schema/static-1.3872",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4272",
  "timezone-utils": "/timezone-utils/static-2.5009",
  "bender-build-tools": "/bender-build-tools/static-1.2899",
  "chatspot-core": "/chatspot-core/static-1.20165",
  "chirp-fetch": "/chirp-fetch/static-1.1647",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2656",
  "stylex": "/stylex/static-1.26",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9388",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3591",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3932",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3486",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17778",
  "growth-data-modal": "/growth-data-modal/static-1.5118",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2834",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1259",
  "navigation-components": "/navigation-components/static-1.17147",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4423",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.275",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7290",
  "ui-universal-auth": "/ui-universal-auth/static-1.8641",
  "user-context": "/user-context/static-1.4859",
  "cms-field-types": "/cms-field-types/static-1.4571",
  "content-icons-ui": "/content-icons-ui/static-1.2142",
  "integrations-lib": "/integrations-lib/static-1.15296",
  "calling-global-api": "/calling-global-api/static-1.63527",
  "calling-internal-common": "/calling-internal-common/static-1.31056",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64909",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57203",
  "commerce-products-lib": "/commerce-products-lib/static-1.8744",
  "crm-links": "/crm-links/static-1.6018",
  "file-manager-components": "/file-manager-components/static-1.22778",
  "google-libphonenumber": "/google-libphonenumber/static-1.32",
  "hs-entities": "/hs-entities/static-1.435",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4018",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.398",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47848",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3755",
  "property-value-citations": "/property-value-citations/static-1.1293",
  "pulse": "/pulse/static-1.265",
  "smart-property-lib": "/smart-property-lib/static-1.5748",
  "tiered-pricing": "/tiered-pricing/static-1.777",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8805",
  "final-form": "/final-form/static-1.64",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19413",
  "tinymce-themes": "/tinymce-themes/static-1.55619",
  "data-token-picker": "/data-token-picker/static-1.15987",
  "hub-http-contrib": "/hub-http-contrib/static-1.2809",
  "interframe": "/interframe/static-3.4556",
  "tinymce-data": "/tinymce-data/static-1.39734",
  "tinymce-plugins": "/tinymce-plugins/static-1.56763",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4977",
  "magpie-lib": "/magpie-lib/static-1.5358",
  "magpie-types": "/magpie-types/static-1.4818",
  "simple-logging-lib": "/simple-logging-lib/static-1.2815",
  "content-assistance-lib": "/content-assistance-lib/static-1.7395",
  "dashboard-lib": "/dashboard-lib/static-1.80462",
  "ExportDialog": "/ExportDialog/static-6.10152",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17501",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17493",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8454",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8182",
  "feedback-loader": "/feedback-loader/static-1.28785",
  "onboarding-scopes": "/onboarding-scopes/static-1.6229",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4413",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.102",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4288",
  "nav-client-types": "/nav-client-types/static-1.2120",
  "purchase-motions-api": "/purchase-motions-api/static-1.5435",
  "trials-service-types": "/trials-service-types/static-1.3689",
  "idb-keyval": "/idb-keyval/static-1.38",
  "reactive-lib": "/reactive-lib/static-1.490",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16896",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12711",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5348",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7553",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10137",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31062",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10802",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6303",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.131",
  "customer-data-tracking": "/customer-data-tracking/static-1.6646",
  "products-iframe-lib": "/products-iframe-lib/static-1.7218",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9772",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8442",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3919",
  "video-components-external": "/video-components-external/static-1.10467",
  "video-data-lib": "/video-data-lib/static-1.34125",
  "directed-graph": "/directed-graph/static-1.701",
  "event-emitter": "/event-emitter/static-1.712",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5268",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9473",
  "fsm": "/fsm/static-1.3496",
  "policy-lib": "/policy-lib/static-1.6549",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9536",
  "navigation-messaging": "/navigation-messaging/static-1.6474",
  "FileManagerLib": "/FileManagerLib/static-1.38418",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8864",
  "FileManagerCore": "/FileManagerCore/static-1.38277",
  "codemirror": "/codemirror/static-5.89",
  "layout-dnd-components": "/layout-dnd-components/static-1.11968",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10943",
  "react-codemirror": "/react-codemirror/static-1.10392",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9654",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13685",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8459",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27848",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8332",
  "payment-link-components": "/payment-link-components/static-1.22834",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23859",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2970",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2763",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34908",
  "sales-views-client-types": "/sales-views-client-types/static-1.4056",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3419",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11320",
  "content-media-compositions": "/content-media-compositions/static-2.15327",
  "media-bridge-lib": "/media-bridge-lib/static-1.18509",
  "trellis-story-utils": "/trellis-story-utils/static-1.4286",
  "storybook-react": "/storybook-react/static-1.27",
  "audio-components": "/audio-components/static-1.5560",
  "FileManagerImages": "/FileManagerImages/static-1.35929",
  "video-components": "/video-components/static-1.12470",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4297",
  "video-embed": "/video-embed/static-1.34959",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67592",
  "layout-data-lib": "/layout-data-lib/static-1.9268",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6350",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5663",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4853",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3441",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-3.69",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.21251",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3607",
  "hls.js": "/hls.js/static-1.33",
  "social-insights-client-types": "/social-insights-client-types/static-1.21253",
  "outpost": "/outpost/static-1.3972",
  "advanced-menus-core": "/advanced-menus-core/static-1.14763",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11745",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33331",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14762",
  "simple-menus-lib": "/simple-menus-lib/static-1.16279"
}
};
